<div class="modal-header">
  <h4 class="modal-title">{{candidateName}}</h4>
  <span type="button" class="btn-close btn-lg" aria-label="Close" aria-hidden="true"
    (click)="activeModal.close('Close click')">&times;</span>
</div>

<div class="modal-body px-0">
  <div class="overflow-hidden" style="overflow-y: hidden; overflow-x: auto; height: calc(100vh - 15rem)">
    <div class="px-2" style="overflow-y: auto; height: 100%;">
      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" style="font-size: 14px;">
        <li *ngFor="let item of navItems" [ngbNavItem]="item.id">
          <a ngbNavLink [ngClass]="{'admin-highlight': !isPortalAdmin && item.requiresAdmin, 
            'active-admin': !isPortalAdmin && nav.activeId == item.id && item.requiresAdmin}">
            {{item.title}}
          </a>
          <ng-template ngbNavContent>
            <ng-container [ngSwitch]="modalType">
              <!-- Candidate Components -->
              <div *ngIf="modalType === 'candidate'">
                <app-candidate-status *ngIf="item.id === 1" [candidateID]="candidateID"></app-candidate-status>
                <app-candidate-details *ngIf="item.id === 2" [candidateID]="candidateID"></app-candidate-details>
                <app-candidate-jobs *ngIf="item.id === 3" [candidateID]="candidateID"></app-candidate-jobs>
                <app-candidate-history *ngIf="item.id === 4" [candidateID]="candidateID"></app-candidate-history>
                <app-candidate-documents *ngIf="item.id === 5" [candidateID]="candidateID"></app-candidate-documents>
                <app-candidate-training *ngIf="item.id === 6" [candidateID]="candidateID"></app-candidate-training>
                <app-candidate-notes *ngIf="item.id === 7" [candidateID]="candidateID" [candidateName]="candidateName" ></app-candidate-notes>
                <app-candidate-deductions *ngIf="item.id === 8" [candidateID]="candidateID" [name]="candidateName" [email]="candidateEmail"></app-candidate-deductions>
                <app-tax-super *ngIf="item.id === 9" [candidateID]="candidateID" [isPortalAdmin]="isPortalAdmin" (parentValueEmitter)="receiveParentValue($event)"></app-tax-super>
                <app-bank-details *ngIf="item.id === 10" [candidateID]="candidateID" [isPortalAdmin]="isPortalAdmin"></app-bank-details>
                <app-candidate-payroll-history *ngIf="item.id === 11" [candidateID]="candidateID" [isPortalAdmin]="isPortalAdmin"></app-candidate-payroll-history>
              </div>
              <!-- Client Components -->
              <ng-container *ngSwitchCase="'client'">
                <app-client-status *ngIf="item.id === 1" [clientID]="clientID" [clientCorporation]="clientCorporation"></app-client-status>
                <app-client-details *ngIf="item.id === 2" [clientID]="clientID"></app-client-details>
                <app-client-organization *ngIf="item.id === 3" [clientID]="clientID" [clientCorporation]="clientCorporation"></app-client-organization>
                <app-client-jobs *ngIf="item.id === 4" [clientID]="clientID" [clientCorporation]="clientCorporation"></app-client-jobs>
                <app-client-candidates *ngIf="item.id === 5" [clientID]="clientID" [clientCorporation]="clientCorporation"></app-client-candidates>
                <app-client-reports *ngIf="item.id === 6" [clientID]="clientID" [clientEmail]="clientEmail"></app-client-reports>
              </ng-container>
            </ng-container>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click');showNewTaxFile=false">
    Close
  </button>
</div>